import React from 'react';
import { Calidad } from '../types';

const calidadSliderValues = [Calidad.LOW, Calidad.MEDIUM, Calidad.HIGH];

interface ControlSidebarProps {
  isOpen: boolean;
  onClose: () => void; // Nueva prop para cerrar el sidebar
  onRestart: () => void;
  onStop: () => void;
  calidad: Calidad;
  onCalidadChange: (calidad: Calidad) => void;
  systemPrompt?: string;
  onSystemPromptChange: (prompt: string) => void;
  showDebug: boolean;
  onShowDebugChange: (show: boolean) => void;
}

export const ControlSidebar: React.FC<ControlSidebarProps> = ({
  isOpen,
  onClose,
  onRestart,
  onStop,
  calidad,
  onCalidadChange,
  systemPrompt = '',
  onSystemPromptChange,
  showDebug,
  onShowDebugChange,
}) => {
  const handleCalidad = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(event.target.value, 10) - 1;
    onCalidadChange(calidadSliderValues[index]);
  };

  return (
    <aside className={`p-4 fixed top-0 left-0 w-64 h-full bg-gray-700 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out flex flex-col overflow-y-auto z-50`}>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-white text-lg">Controles</h2>
        <button 
          onClick={onClose}
          className="text-white hover:text-gray-300 transition-colors"
          aria-label="Cerrar panel de control"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      
      <div className="flex space-x-2 mb-4">
        <button onClick={onRestart} className="p-4 flex-1 flex flex-col items-center justify-center bg-blue-500 text-white rounded text-lg">
          <span className="icon-[solar--restart-circle-bold] text-2xl mb-2"></span>
          Reiniciar
        </button>
        <button onClick={onStop} className="p-4 flex-1 flex flex-col items-center justify-center bg-red-500 text-white rounded text-lg">
          <span className="icon-[wpf--shutdown] text-2xl mb-2"></span>
          Stop
        </button>
      </div>

      <div className="mb-4">
        <label className="block text-white mb-2" htmlFor="calidad">Calidad</label>
        <input
          type="range"
          min="1"
          max="3"
          value={(calidadSliderValues.indexOf(calidad) + 1).toString()}
          onChange={handleCalidad}
          className="w-full h-2 rounded-lg appearance-none cursor-pointer"
          id="calidad"
        />
        <div className="flex justify-between mt-2">
          <span className={calidad === Calidad.LOW ? "text-blue-500" : "text-gray-500"}>Baja</span>
          <span className={calidad === Calidad.MEDIUM ? "text-blue-500" : "text-gray-500"}>Media</span>
          <span className={calidad === Calidad.HIGH ? "text-blue-500" : "text-gray-500"}>Alta</span>
        </div>
      </div>

      <div className="mb-4">
        <label className="block text-white mb-2" htmlFor="systemPrompt">System Prompt</label>
        <textarea
          id="systemPrompt"
          value={systemPrompt}
          onChange={(e) => onSystemPromptChange(e.target.value)}
          placeholder="Ingrese un system prompt personalizado..."
          className="w-full h-32 p-2 bg-gray-800 text-white rounded resize-none"
        />
      </div>

      <div className="mb-4">
        <label className="flex items-center text-white cursor-pointer">
          <input
            type="checkbox"
            checked={showDebug}
            onChange={(e) => onShowDebugChange(e.target.checked)}
            className="mr-2"
          />
          Mostrar mensajes de depuración
        </label>
      </div>
    </aside>
  );
};
